import { COLORS } from '@btime/constants'
import { useFilterActions, useFilterChecker } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { SmallText } from '../presentation/Text'
import Button from '../actions/Button'
import Link from '../actions/Link'
import List from '../list/List'
import SideModal, { SideModalHeader } from '../structure/SideModal'

const FiltersModal = ({ open, onClose, children }) => {
  const { t } = useTranslation('common')
  const { hasFilter } = useFilterChecker()
  const { clearFilter } = useFilterActions()

  let clearFilterLink = false
  if (hasFilter)
    clearFilterLink = (
      <Link onClick={clearFilter}>
        <SmallText color={COLORS.red}>{t('clean')}</SmallText>
      </Link>
    )

  return (
    <SideModal
      open={open}
      onClose={onClose}
      footer={
        <Button fullWidth onClick={onClose}>
          {t('applyFilters')}
        </Button>
      }
    >
      <SideModalHeader title={t('filter')} onClose={onClose} leftContent={clearFilterLink} />
      <List>{children}</List>
    </SideModal>
  )
}

export default FiltersModal
